export { default as getSecret } from './getSecret'
